var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopy = function SvgCopy(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-20": 14,
    "data-width-24": 17,
    viewBox: "0 0 12 12",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.587 3.516a1.07 1.07 0 0 0-1.071 1.07V9.84a1.07 1.07 0 0 0 1.07 1.07H9.84a1.07 1.07 0 0 0 1.07-1.07V4.587a1.07 1.07 0 0 0-1.07-1.071zm-1.529-.458a2.16 2.16 0 0 1 1.529-.633h5.252A2.16 2.16 0 0 1 12 4.587v5.252A2.16 2.16 0 0 1 9.839 12H4.587a2.163 2.163 0 0 1-2.162-2.162V4.587c0-.574.228-1.124.633-1.529",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.758 1.09a.67.67 0 0 0-.667.668v6.06a.67.67 0 0 0 .337.579.545.545 0 1 1-.539.948A1.76 1.76 0 0 1 0 7.82V1.758C0 .79.79 0 1.758 0h6.06q.495 0 .868.267c.236.171.396.4.518.62a.545.545 0 0 1-.953.53c-.086-.154-.153-.228-.206-.267-.041-.03-.102-.06-.227-.06z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export default ForwardRef;